<template>
    <v-layout wrap>
        <header>
            <div class="logo">
                <img src="/assets/logo.png" alt="Raumkarte Schwalm Aue"/>
            </div>
            <v-btn-toggle v-model="mapMode" mandatory>
                <div class="btn-switch">
                    <v-btn text value="map" class="toggle-button">
                        Karte
                    </v-btn>
                    <v-btn text value="list" class="toggle-button">
                        Liste
                    </v-btn>
                </div>
            </v-btn-toggle>
            <div class="buttons-left">
                <v-tooltip bottom>
                    <template #activator="{ on }">
                        <button v-on="on" class="btn-icon icon-mode-select" @click="activeTool = 'pointer'" :class="{'active': activeTool === 'pointer'}"></button>
                    </template>
                    <span>Select</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template #activator="{ on }">
                        <button v-on="on" class="btn-icon icon-mode-create" @click="activeTool = 'create'" :class="{'active': activeTool === 'create'}"></button>
                    </template>
                    <span>Erstellen</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template #activator="{ on }">
                        <button v-on="on" class="btn-icon icon-mode-draw" @click="activeTool = 'draw'" :class="{'active': activeTool === 'draw'}"></button>
                    </template>
                    <span>Zeichnen</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template #activator="{ on }">
                        <button v-on="on" class="btn-icon icon-mode-measure" @click="activeTool = 'measure'" :class="{'active': activeTool === 'measure'}"></button>
                    </template>
                    <span>Messen</span>
                </v-tooltip>
            </div>
            <geo-filter></geo-filter>
            <div class="buttons-right">
                <v-tooltip bottom>
                    <template #activator="{ on }">
                        <v-badge overlap color="#2ED1DF" v-if="isAdmin">
                            <template #badge>
                                <span v-if="getQueueErrorsLength > 0">{{ getQueueErrorsLength }}</span>
                            </template>
                            <button v-on="on" class="btn-icon icon-logout" @click="startImport"></button>
                        </v-badge>
                    </template>
                    <span>Import</span>
                </v-tooltip>
                <button class="btn-icon icon-export-immo" v-if="canSyncImmoscout" @click="openImmoscoutSync"></button>
                <user-icon class="sr-avatar" :user="getCurrentUser" :menu="userMenu" @click="handleUserMenuClick"></user-icon>
            </div>
        </header>

        <v-content class="sr-map">
            <router-view></router-view>
        </v-content>
    </v-layout>
</template>

<script>
  import UserIcon from '@/components/UserIcon'
  import GeoFilter from '@/components/filter/GeoFilter'
  import Import from '@/models/Import'
  import ImportHeaderComponent from '@/components/toolbox/import/Header'
  import ImportFooterComponent from '@/components/toolbox/import/Footer'
  import ImmoscoutHeaderComponent from '@/components/toolbox/immoscout/Header'
  import ImmoscoutFooterComponent from '@/components/toolbox/immoscout/Footer'
  import UserHeaderComponent from '@/components/toolbox/user/Header'
  import HelpListHeaderComponent from '@/components/toolbox/help/Header'
  import User from '@/models/User'
  import UserApi from '@/api/user'
  import ImportApi from '@/api/importer'
  import ImmoscoutApi from '@/api/immoscout'
  import QueueHelper from '@/helper/QueueHelper'
  import LoginHelper from '@/helper/LoginHelper'
  import HelpList from '@/models/HelpList'
  import ImmoScoutSync from '@/models/ImmoScoutSync'

  export default {
    mixins: [],
    components: { UserIcon, GeoFilter },
    mounted () {
    },
    beforeDestroy () {
      QueueHelper.destroy()
      LoginHelper.destroy()
    },
    created () {
      this.$resolve(['search/fetchSearchOptions'])
    },
    data () {
      return {
        queueHelper: null,
        clipped: false,
        tools: {
          pointer: 'near_me',
          create: 'add_circle_outline',
          draw: 'error',
          measure: 'warning'
        },
        userMenu: [
          {
            id: 'profile',
            title: 'Edit Profile'
          },
          {
            id: 'help',
            title: 'Hilfe'
          },
          {
            id: 'logout',
            title: 'Logout'
          }
        ]
      }
    },
    methods: {
      handleUserMenuClick (item) {
        switch (item.id) {
          case 'logout':
            this.$store.dispatch('auth/logout')
            break
          case 'tpl':
            this.$toolbox.open({
              item: {
                getToolboxTabs: () => {
                  return {
                    edit: {
                      tab: () => import('@/components/toolbox/geoobject/Edit'),
                      icon: 'edit'
                    }
                  }
                }
              }
            })
            break
          case 'profile':
            this.$toolbox.open({
              item: new User(this.getCurrentUser),
              layoutOptions: {
                headerComponent: UserHeaderComponent
              },
              onConfirm: (toolbox) => UserApi.update(toolbox.contentData),
              onConfirmError: (toolbox, error) => console.log(toolbox, error)
            }).then((result) => {
              if (result.confirmed) {
                this.$alert.success('Nutzerdaten gespeichert')
              }
              if (result.onConfirm) {
                this.$store.dispatch('auth/setIdentity', result.onConfirm.user)
              }
            })

            break
          case 'help':
            this.$toolbox.open({
              item: new HelpList(this.$store),
              layoutOptions: {
                headerComponent: HelpListHeaderComponent,
                footerComponent: null
              }
            })
            break
          default:
        }
      },
      startImport () {
        this.$toolbox.open({
          item: new Import(),
          dialogOptions: {
            width: 670
          },
          layoutOptions: {
            headerComponent: ImportHeaderComponent,
            footerComponent: ImportFooterComponent
          },
          onConfirm: (toolbox) => ImportApi.import(toolbox.contentData),
          onConfirmError: (toolbox, error) => this.$alert.error('Fehler: ' + error.response.data.error)
        }).then((result) => {
          if (result.confirmed) {
            this.$alert.success('Import wird im Hintergrund ausgeführt')
          }
        })
      },
      openImmoscoutSync () {
        this.$toolbox.open({
          item: new ImmoScoutSync(),
          dialogOptions: {
            width: 670
          },
          layoutOptions: {
            headerComponent: ImmoscoutHeaderComponent,
            footerComponent: ImmoscoutFooterComponent
          },
          onConfirm: async () => ImmoscoutApi.synchronize(),
          onConfirmError: (toolbox, error) => this.$alert.error('Fehler: ' + error.response.data.error)
        }).then((result) => {
          if (result.confirmed) {
            this.$alert.success('Synchronisierung der Daten erfolgreich')
          }
        })
      }
    },
    computed: {
      isAdmin () {
        return this.$store.getters['auth/checkPermissions']('admin') || this.$store.getters['auth/checkPermissions']('import')
      },
      canSyncImmoscout () {
        return this.$store.getters['auth/checkPermissions']('admin') || this.$store.getters['auth/checkPermissions']('immoscout')
      },
      getCurrentUser () {
        return this.$store.getters['auth/getIdentity']
      },
      getQueueErrorsLength () {
        return this.$store.getters['queue/getEntries'].filter((entry) => entry.error).length
      },
      mapMode: {
        get () {
          return this.$store.getters['geoview/getMapMode']
        },
        set (value) {
          this.$store.dispatch('geoview/setMapMode', value)
        }
      },
      activeTool: {
        get () {
          return this.$store.getters['geoview/getActiveTool']
        },
        set (value) {
          return this.$store.dispatch('geoview/setActiveTool', value)
        }
      }
    }
  }
</script>
